import React, { useEffect } from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { MaterialsSection } from './components/MaterialsSection';
import { ScreenTime } from './components/ScreenTime';
import { ForYourChild } from './components/ForYourChild';
import { HowItWorks } from './components/HowItWorks';
import { WhyItWorks } from './components/WhyItWorks';
import { VideoPreview } from './components/VideoPreview';
import { ProjectsGallery } from './components/ProjectsGallery';
import { WhatsIncluded } from './components/WhatsIncluded';
import { Offer } from './components/Offer';
import { BonosCarousel } from './components/BonosCarousel';
import { Testimonials } from './components/Testimonials';
import { FinalOffer } from './components/FinalOffer';
import { Faq } from './components/Faq';
import { StickyCta } from './components/StickyCta';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    const pixelId = '1587807052693164';

    // @ts-ignore
    !function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      b.head.appendChild(t);
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

    // @ts-ignore
    window.fbq('init', pixelId);
    // @ts-ignore
    window.fbq('track', 'PageView');
  }, []);
  return <div className="w-full min-h-full bg-white" data-id="element-0" data-mp="33m5b01uz1i7a">
      <Navbar data-id="element-1" data-mp="33mymth8sexwa" />
      <main data-id="element-2" data-mp="33orkw85c49so">
        <Hero data-id="element-3" data-mp="38lrq6gud18iq" />
        <MaterialsSection data-id="element-4" data-mp="38l8idsyfc0if" />
        <ScreenTime data-id="element-5" data-mp="38l04bxqkep5n" />
        <ForYourChild data-id="element-6" data-mp="38kgk2adfzoog" />
        <HowItWorks data-id="element-7" data-mp="38o4d78ez692n" />
        <WhyItWorks data-id="element-8" data-mp="3dle1gkqmoeow" />
        <VideoPreview data-id="element-9" data-mp="3dlw5i3jj7x7d" />
        <ProjectsGallery data-id="element-10" data-mp="3dmfmni1cyhkc" />
        <WhatsIncluded data-id="element-11" data-mp="3dii694660445" />
        <Offer data-id="element-12" data-mp="nw2ak1lu1ioz" />
        <BonosCarousel data-id="element-13" data-mp="nuhged3fk1rn" />
        <Testimonials data-id="element-14" data-mp="nv0x5qhcgk43" />
        <FinalOffer data-id="element-15" data-mp="nxwwnj8ubgun" />
        <Faq data-id="element-16" data-mp="sudmqizlo5ad" />
      </main>
      <Footer data-id="element-17" data-mp="stkn01z26g1q" />
      <StickyCta data-id="element-18" data-mp="st2heeqiaph5" />
    </div>;
}